/*
 * A sintaxe a mais do conteúdo (extend/cooked.php) no fórum: as notas de
 * rodapé nos posts e na prévia, o sumário na coluna da linha do tempo (e na
 * folha da linha do tempo do celular), e os atalhos "Nota de rodapé" e
 * "Inserir sumário" no menu ⊕ do composer.
 */
import app from 'flarum/forum/app';
import { extend, override } from 'flarum/common/extend';
import CommentPost from 'flarum/forum/components/CommentPost';
import DiscussionPage from 'flarum/forum/components/DiscussionPage';
import { addMoreAction } from '../../composer/installToolbar';
import { t } from '../../utils/settings';
import { decorateFootnotes, footnotesOn } from './footnotes';
import TableOfContents, { tocFor, tocOn, tocToggle, tocVisible } from './toc';
const EDIT = 'flarum/forum/components/EditPostComposer';
const DISCUSSION = 'flarum/forum/components/DiscussionComposer';
function installFootnotes() {
  extend(CommentPost.prototype, ['oncreate', 'onupdate'], function () {
    const body = this.element?.querySelector?.('.Post-body');
    if (body) decorateFootnotes(body);
  });

  // A prévia do composer é desenhada pelo formatador em JS, a cada mudança.
  if (typeof s9e !== 'undefined' && s9e?.TextFormatter) {
    override(s9e.TextFormatter, 'preview', function (original, ...args) {
      const [text, element] = args;
      original(text, element);
      decorateFootnotes(element);
    });
  }
  addMoreAction(() => {
    if (!footnotesOn() || !app.composer.isVisible() || !app.composer.editor) return null;
    return {
      key: 'canelaFootnote',
      icon: 'fas fa-asterisk',
      label: t('footnotes.add'),
      onclick: () => app.composer.editor?.insertAtCursor(`^[${t('footnotes.placeholder')}]`, false)
    };
  });
}

/** O primeiro post do que está sendo escrito: a discussão nova ou a edição do post 1. */
function writingFirstPost() {
  const composer = app.composer;
  if (composer.bodyMatches(DISCUSSION)) return true;
  return composer.bodyMatches(EDIT) && composer.body?.attrs?.post?.number?.() === 1;
}

/**
 * A coluna da linha do tempo existe (Topic.less: a partir de 925px). Abaixo
 * disso a linha do tempo é a aba "1 / 11" com a folha, e o sumário vai nela.
 */
function hasColumn() {
  return window.matchMedia('(min-width: 925px)').matches;
}
function installToc() {
  extend(DiscussionPage.prototype, 'sidebarItems', function (items) {
    const toc = hasColumn() ? tocFor(this.discussion) : null;
    document.body.classList.toggle('CanelaToc--active', !!toc && (tocVisible() || (this.discussion?.commentCount?.() || 0) <= 1));
    if (!toc) return;
    const single = (this.discussion.commentCount?.() || 0) <= 1;
    if (single || tocVisible()) {
      if (items.has('scrubber')) items.remove('scrubber');
      items.add('canelaToc', m(TableOfContents, {
        post: toc.post,
        tree: toc.tree,
        stream: this.stream
      }), -100);
    }
    if (!single) items.add('canelaTocToggle', tocToggle(), -1000);
  });
  extend(DiscussionPage.prototype, 'onremove', () => document.body.classList.remove('CanelaToc--active'));

  // Sem a coluna (celular e tablet estreito): o sumário dentro da folha da
  // linha do tempo, abaixo do resumo.
  extend('flarum/forum/components/PostStreamScrubber', 'view', function (vnode) {
    if (hasColumn() || !vnode || !Array.isArray(vnode.children)) return;
    const menu = vnode.children.find(child => child && child.attrs && /Dropdown-menu/.test(child.attrs.className || ''));
    const toc = tocFor(this.stream?.discussion);
    if (!menu || !toc || !Array.isArray(menu.children)) return;
    menu.children.push(m("div", {
      className: "CanelaToc-sheet"
    }, m("h3", null, t('toc.title')), m(TableOfContents, {
      post: toc.post,
      tree: toc.tree,
      stream: this.stream
    })));
  });
  addMoreAction(() => {
    if (!tocOn() || !app.composer.isVisible() || !app.composer.editor || !writingFirstPost()) return null;
    return {
      key: 'canelaToc',
      icon: 'fas fa-list-ul',
      label: t('toc.insert'),
      onclick: () => app.composer.editor?.insertAtCursor('[toc]\n', false)
    };
  });
}
export default function installCooked() {
  installFootnotes();
  installToc();
}
flarum.reg.add('ramon-canela', 'forum/features/cooked', installCooked);